import * as fetchService from '../../shared/services/fetch';
import { getBasePath } from '../../shared/services/get-base-path';
import { handleError } from '../../shared/services/error-handlers';
// import { getUserIdFromSessionStorage } from '../../shared/services/user-service';

const basePath = getBasePath();
// let loggedInUserId = getUserIdFromSessionStorage();

function getClaimAPIsURL ( mode, warrantyClaimID ) {

    const url = `${basePath}/claims/${warrantyClaimID}`;
    switch ( mode ) {

    case 'claimPartDetails': return `${url}/prime-part`;
    case 'claimSupplierInformation': return `${url}/supplier-information`;
    case 'claimAttachments': return `${url}/attachments`;
    case 'claimComplaint': return `${url}/complaint`;
    case 'claimCause': return `${url}/cause`;
    case 'claimCorrection': return `${url}/correction`;
    case 'claimSettlement': return `${url}/settlement`;
    case 'claimAnalysis': return `${url}/analysis-comments`;
    case 'claimReplacementParts': return `${url}/replacement-parts`;
    case 'claimAuditMessages': return `${url}/audit-messages`;
    case 'claimLabor': return `${url}/labor`;
    default: return url;

    }

}

export async function getClaimDetails ( mode, claimNumber ) {

    // const endPoint = `${basePath}/claims/${claimNumber}`;
    const endPoint = getClaimAPIsURL( mode, claimNumber );

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}


function getClaimUpdateURL ( mode, warrantyClaimID ) {

    const url = `${basePath}/claims/${warrantyClaimID}`;
    switch ( mode ) {

    case 'machineWarranty': return `${url}/claim-header`;
    case 'auditMessages': return `${url}/update-audit-message`;
    case 'claimAnalysis': return `${url}/analysis-comments`;
    case 'functionCode': return `${url}/update-function-code`;
    case 'functionCode-otherFields': return `${url}/details`;
    case 'primePartFailure': return `${url}/update-part-number`;
    case 'component-function-code': return `${url}/update-component-function-code`;
    default: return url;

    }

}


export async function updateClaimDataByMode ( mode, warrantyClaimId, updatedData ) {

    let endPoint = getClaimUpdateURL( mode, warrantyClaimId );

    const options = {
        body: JSON.stringify( updatedData ),
        method: 'PUT',
    };
    if ( mode === 'basic' ) {

        endPoint = `${basePath}/claims/${warrantyClaimId}/pin-update?correctedPinNumber=${updatedData}`;

        delete options.body;

    }

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getFactoryFailureCodeList () {

    const endPoint = `${basePath}/factory-failure-code`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getFactorySystemEffectList () {

    const endPoint = `${basePath}/factory-system-effect`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAccountingFactoryList ( analysisFactoryCode ) {

    const endPoint = `${basePath}/accounting-factory?analysisFactoryCode=${analysisFactoryCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getComponentFailureCodeList ( ) {

    const endPoint = `${basePath}/component-failure-modes`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getComponentsystemEffectList ( ) {

    const endPoint = `${basePath}/component-system-effects`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function generateClaimPDF ( warrantyClaimId ) {

    const endPoint = `${basePath}/claims/${warrantyClaimId}/generate-claim-pdf`;

    const options = {
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}


// export async function getClaimDetailsPDF (  searchedData ) {
//
//     const endPoint = `${basePath}/claims/ClaimsPdf`;
//
//     const options = {
//         body: JSON.stringify( searchedData ),
//         method: 'POST',
//     };
//
//     try {
//
//         const response = await fetchService.fetch( endPoint, options );
//
//         return response;
//
//     } catch ( error ) {
//
//         return handleError( error );
//
//     }
//
// }

export async function getClaimDetailsPDF(searchedData) {

    const endPoint = `${basePath}/claims/ClaimsPdf`;



    const options = {

        body: JSON.stringify(searchedData),

        method: 'POST',

    };

    try {
        const response = await fetchService.fetch(endPoint, options);
        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'CreditMemoDetails.pdf';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } else {
            console.error('Failed to fetch PDF:', response.statusText);
        }
    } catch (error) {
        console.error('Error fetching PDF:', error);
    }
}